import React from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import {
    ListCompetitionName,
    ListItemName,
    ListItemShortcut,
    ListOpenIcon,
    ShortEventListItem,
} from 'src/components/TradingEvents/ShortEventsList/ShortEventsListElement.style';
import { observer } from 'src/utils/mobx-react';
import { DateTime } from 'src_common/utils/time/time';

interface PropsType {
    eventId: number;
}

export const ShortEventsListElement = observer('ShortEventsListElement', (props: PropsType) => {
    const appState = useAppStateContext();

    const eventId = props.eventId;
    const isOpened = appState.sportsbookState.eventPageState.openedEvents.includes(eventId);
    const eventModel = appState.websocketV2.getEvent(eventId);

    if (eventModel === null) {
        return null;
    }

    const onOpen = (e: React.MouseEvent<HTMLSpanElement>): void => {
        e.preventDefault();
        appState.routerBackoffice.redirectToTradingEvent(eventId);
        appState.sportsbookState.eventPageState.addEvent(eventId);
        appState.sportsbookState.eventPageState.addToRecentlyViewed(eventId);
    };

    const onToggle = (): void => {
        if (isOpened) {
            appState.sportsbookState.eventPageState.removeEvent(eventId);
        } else {
            appState.sportsbookState.eventPageState.addEvent(eventId);
            appState.sportsbookState.eventPageState.addToRecentlyViewed(eventId);
        }
    };

    const competitionModel = appState.websocketV2.getCompetitionModel(eventModel.competition);
    const competitonName = competitionModel?.name ?? '';
    const eventStartTime = DateTime.from(eventModel.timeSettingsStartTime);

    return (
        <ShortEventListItem>
            <ListOpenIcon
                isActive={isOpened}
                onClick={onToggle}
            >
                {isOpened ? '-' : '+'}
            </ListOpenIcon>

            <ListItemShortcut>{eventModel.sport.substr(0, 2).toUpperCase()}</ListItemShortcut>
            <ListCompetitionName onClick={onOpen}>
                <ListItemName>{eventModel.name}</ListItemName>
                {competitonName} | {eventStartTime?.format('HH:mm')} ({eventStartTime?.fromNow()})
            </ListCompetitionName>
        </ShortEventListItem>
    );
});
